/**
 * [合作协议]
 * @author: Fu Xiaochun
 * @date: 2022-05-30 
 */

import React, { useEffect, useState, forwardRef, useImperativeHandle } from 'react';
import styles from './index.module.scss';
import { Modal, Button, Input, Select, InputNumber, message, Radio, DatePicker, Checkbox } from 'antd';
import CusotmUpload, { generateFileList } from '@/components/NewUpload';
import { findAreaByParentId } from '@/apis/common';
import moment from 'moment';
import { GenerateUUID } from '@/util/utils';
import PropTypes from 'prop-types';

function Agreements(props, ref) {

    // 合作协议
    const [agreementsFile, setAgreementsFile] = useState();  // 协议文件
    const [agreementsTime, setAgreementsTime] = useState();  // 协议有效期

    useEffect(() => {
        if (props.detail.id) {
            initData();
        }
    }, [props.detail]);

    const initData = () => {
        let detail = props.detail;
        setAgreementsFile({ uid: GenerateUUID(), url: detail.agrtFileUrl });
        setAgreementsTime(detail.agrtEndTime);
    };

    const fileChange = (data = {}) => {
        let _file;
        if (Array.isArray(data.fileList)) {
            data.fileList.forEach(v => {
                if (v.status == 'success') {
                    _file = v;
                }
            });
        }
        setAgreementsFile(_file);
    };

    const disabledDate = (current) => {
        return current && current < moment().endOf('day');
    };

    useImperativeHandle(ref, () => ({
        getState: () => {
            return {
                agreementsFile: agreementsFile?.url,
                agreementsTime,
            };
        }
    }));

    return (
        <div className={styles.cooperationAgreements}>
            <div className={styles.item}>
                <div className={styles.agreementsCard}>
                    <CusotmUpload accept='.png, .jpg, .jpeg, .pdf' listType='picture-card' wallMode='single'
                        fileList={agreementsFile ? [agreementsFile] : null}
                        onFileListChange={fileChange}
                        removeError
                        qiniuUploadProps={{ uploadType: 'image' }}
                        beforeUpload={file => {
                            const isType = ['image/png', 'image/jpeg', 'image/jpg', 'application/pdf'];
                            const isLt5M = file.size / 1024 / 1024 > 5;
                            if (!isType.includes(file.type)) {
                                message.warn('只能上传png,jpg, jpeg, pdf格式的图片或文件!');
                                file.status = 'error';
                                return false;
                            } else if (isLt5M) {
                                message.warn('图片必须小于 5MB!');
                                file.status = 'error';
                                return false;
                            }
                        }}
                    >
                        <div style={{ color: '#999999', fontSize: '12px' }}>上传合作协议</div>
                    </CusotmUpload>
                </div>
                <div className={styles.extTxt}>仅支持PNG、JPG、JPEG、PDF格式，文件大小不大于5M。</div>
            </div>
            <div className={styles.item}>
                <div className={styles.label}>协议有效期：</div>
                <div className={styles.val}>
                    <DatePicker className={styles.txt} disabledDate={disabledDate} value={agreementsTime ? moment(agreementsTime, 'YYYY-MM-DD') : ''} onChange={(date, dateStr) => { setAgreementsTime(dateStr); }} format={'YYYY-MM-DD'} />
                </div>
            </div>
        </div>
    );
}

const RefAgreements = forwardRef(Agreements);

Agreements.propTypes = {
    detail: PropTypes.object,
};

Agreements.defaultProps = {
    detail: {}
};


export default RefAgreements;